<template lang="pug">
  .monitor-entrance-wrapper
    .time
      div
        span(style="margin-right: 5px;") {{ time }}
        .icon-ptt-icons-recarregar.fs-15.to-click(
          @click="setAutoRefresh",
          title="clique para atualizar" style="display: inline-block;"
          :class="{'spin-time': loading}"
        )

      span horário local

    h2 acompanhamento de entrada

    Slider(v-model="painelView")
      | painel

    .painel(v-if="painelView")
      .select
        PSelect(
          labelItem="name"
          v-model="companyFilter"
          :title="$ws('company')"
          useCommon="companies"
        )
      .painels
        div
          EmployeeAccordion(v-for="(item, index) in entries[0]" :data="item", :key="index")
        div
          EmployeeAccordion(v-for="(item, index) in entries[1]" :data="item", :key="index")
        div
          EmployeeAccordion(v-for="(item, index) in entries[2]" :data="item", :key="index")

    .table(v-if="!painelView")
      SmartTable.table(
        name="monitor-workplace-list"
        v-bind="table"
        v-model="tableData"
        ref="table"
      )
        template(v-slot:default="slotProps")
          TableRow(v-bind="slotProps")
            template(v-slot:company.name="{ columnValue, rowItem }")
              span.name-table(:style="{'border-color': rowItem.company.color}") {{ columnValue }}

            template(v-slot:entryTime="{ columnValue }")
              span(
                :style="estiloPorHorarioDeEntrada(columnValue)"
              )
                | {{ formatHour(columnValue) }}

        template(v-slot:detailsBox="{item}")
          .details
            DBLabel(title="nome:", :body="item.employee.name")
            DBLabel(title="local de trabalho:", :body="item.company.name")
            DBLabel(title="horário de entrada:", :body="formatHour(item.entryTime)")

            .buttons
              PButton(
                color="info"
                size="md"
                @click="goToEmployee(item.employee.id)"
                title="ir para folha"
              )
                span.icon-ptt-icons-folha
              PButton(
                color="info"
                size="md"
                @click="goToCompany(item.company.id)"
                title="ir para folha do local de trabalho"
              )
                span.icon-ptt-icons-pessoas

</template>

<script>
import EmployeeAccordion from './EmployeeAccordion'
import moment from 'moment'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  mounted () {
    setAmplitudeEvent('lista acompanhamento de entrada', {})
  },
  created () {
    this.getData()
    this.setAutoRefresh()
  },
  beforeDestroy () {
    this.cancelarIntervalos()
  },
  data () {
    return {
      loading: false,
      time: moment().format('HH:mm'),
      interval: null,
      data: null,
      painelView: false,
      table: {
        headerItems: [
          {column: this.$ws('employee'), field: 'employee.name', width: '1fr'},
          {column: 'horário de entrada', field: 'entryTime', width: '.3fr'},
          {column: 'local de trabalho', field: 'company.name', width: '1fr'}
        ],
        config: {
          perPage: 15,
          startFocusedSearch: 'employee.name',
          defaultSortField: 'employee.name',
          defaultColumnSearch: 'employee.name',
          defaultFilterText: {field: 'employee.name', text: ''},
          detailsBox: {
            numberColumnsKeep: 1
          }
        }
      },
      companyFilter: { selected: null }
    }
  },
  computed: {
    tableData: {
      get () {
        if (!this.data) return {loading: false, loaded: []}

        return {
          loading: false,
          loaded: this.data.entries
        }
      },
      set () {}
    },
    entries () {
      const data = this.companyFilter.selected
        ? this.tableData.loaded.filter(d => d.company.id === this.companyFilter.selected.id)
        : this.tableData.loaded
      const divide = Math.ceil(data.length / 3)
      return [
        data.slice(0, divide),
        data.slice(divide, divide * 2),
        data.slice(divide * 2, data.length)
      ]
    }
  },
  methods: {
    cancelarIntervalos () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    setAutoRefresh () {
      this.cancelarIntervalos()

      this.time = moment().format('HH:mm')
      this.interval = setInterval(() => {
        this.time = moment().format('HH:mm')
        this.getData()
      }, 180 * 1000)
    },
    async getData () {
      this.loading = true
      const result = await this.$API.realTime.get({timezone: Intl.DateTimeFormat().resolvedOptions().timeZone})
      this.data = Object.freeze(result.data.success)
      this.loading = false
    },
    formatHour (value) {
      if (value) {
        return moment(value).format('HH:mm')
      }
      return '-'
    },
    goToEmployee (id) {
      const employee = this.$store.state.common.employees.items.find(i => i.id === id)
      this.$router.goToTimesheet(moment(), employee, null, true)
    },
    goToCompany (id) {
      const company = this.$store.state.common.companies.items.find(i => i.id === id)
      this.$router.goToTimesheet(moment(), null, company, true)
    },
    estiloPorHorarioDeEntrada (data) {
      const estilos = {
        esperado: 'blue',
        faltando: 'red'
      }

      const horarioAtual = moment()
      const horarioDeInicioDaJornada = moment(data).set({
        year: horarioAtual.year(),
        month: horarioAtual.month(),
        date: horarioAtual.date()
      })

      const aindaVaiComecarAJornada = horarioAtual.isBefore(horarioDeInicioDaJornada)
      return {
        color: aindaVaiComecarAJornada ? estilos.esperado : estilos.faltando
      }
    }
  },
  components: {EmployeeAccordion}
}
</script>

<style lang="scss" scoped>
.monitor-entrance-wrapper {
  display: grid;
  grid-template-columns: 0.5fr 1fr .5fr;
  align-items: baseline;

  h2 {grid-column: 2/3; text-align: center;}

  .time {
    text-align: center;
    div {
      font-weight: bold;
      font-size: 25px;

      .spin-time {
        @keyframes spin {
          from {
            transform:rotate(0deg);
          }
          to {
            transform:rotate(360deg);
          }
        }

        padding-top: 1px;
        animation-name: spin;
        animation-duration: 500ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
    }
  }

  .painel {
    grid-column: 1/4;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 30px;

    .select {
      grid-column: 3/4;
    }
    .painels {
      grid-column: 1/4;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 30px;

      > div {
        display: grid;
        grid-row-gap: 30px;
        height: fit-content;
      }
    }
  }

  .painels, .table {
    margin-top: 30px;
  }

  .table {
    grid-column: 1/4;

    .name-table {
      border-left: 5px solid;
      height: 100%;
      padding-left: 5px;
      margin-left: -20px;
      display: grid;
      align-items: center;
    }

    .details {
      display: grid;
      grid-row-gap: 10px;
      grid-template-columns: 1fr 1fr;

      .buttons {
        display: grid;
        grid-auto-flow: column;
        grid-gap: 2px;
        grid-column: 1/3;
        grid-row: 3;
        justify-self: right;
      }
    }
  }
}
</style>
